import { hasVariantDefinition } from './hasVariantDefinition';

/**
 * Z pole variant vygeneruje pole variant, které mají nastavou hodnotu atributu
 * 
 * @param variants 
 * @param attribute
 * @param value 
 */
export const findVariantsWithDefinition = (
  variants: GQL.IProductVariant[], 
  attribute: GQL.IAttribute, 
  value: GQL.IAttributeValue
) => {
  if (variants) {
    return variants.filter((v: GQL.IProductVariant) => hasVariantDefinition(v, attribute, value));
  }

  return [];
};


// WEBPACK FOOTER //
// ./src/helpers/variants/findVariantWithDefinition.ts